(function () {
  var glyphs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  function scramble(target, progress) {
    var n = Math.floor(target.length * progress);
    var s = '';
    for (var i = 0; i < target.length; i++) {
      if (target[i] === ' ') { s += ' '; continue; }
      s += i < n ? target[i] : glyphs.charAt(Math.floor(Math.random() * glyphs.length));
    }
    return s;
  }

  function initOne(root) {
    if (!root || root.getAttribute('data-hw-tease-init') === '1') return;
    root.setAttribute('data-hw-tease-init', '1');
    root.classList.add('hw-tease--js');

    var out = root.querySelector('[data-hw-decode]');
    var kicker = root.querySelector('[data-hw-kicker]');
    var bar = root.querySelector('[data-hw-bar]');
    var topL = root.querySelector('[data-hw-top-l]');
    var topR = root.querySelector('[data-hw-top-r]');
    var s2 = root.querySelector('[data-hw-s2]');
    var s3 = root.querySelector('[data-hw-s3]');
    var s4 = root.querySelector('[data-hw-s4]');
    if (!out) return;

    var target = (root.getAttribute('data-hw-target') || 'NEW PRODUCT ANNOUNCEMENT').toUpperCase();
    var started = Date.now();
    var duration = 4200;
    var holdAfterOpen = 3200;
    var locked = false;
    var revealed = false;
    var finished = false;

    function reveal() {
      if (revealed) return;
      revealed = true;
      if (topL) topL.innerHTML = 'Signal <b>Acquired</b>';
      if (topR) topR.innerHTML = 'Status <b>Live</b>';
      root.classList.add('is-revealed');
    }

    function finish() {
      if (finished) return;
      finished = true;
      out.textContent = target;
      if (kicker) kicker.textContent = 'Transmission held';
      if (bar) bar.style.width = '100%';
      if (s2) s2.className = 'on';
      if (s3) s3.className = 'on';
      if (s4) s4.className = 'on';
      root.classList.add('is-open');
      if (!revealed) setTimeout(reveal, holdAfterOpen);
    }

    function tick() {
      try {
        var p = Math.min(1, (Date.now() - started) / duration);
        if (bar) bar.style.width = (p * 100) + '%';
        if (p < 0.28) {
          if (kicker) kicker.textContent = 'Acquiring signal';
        } else if (p < 0.58) {
          if (kicker) kicker.textContent = 'Decrypting payload';
          if (s2) s2.className = 'on';
        } else if (p < 0.82) {
          if (kicker) kicker.textContent = 'Redacting identifiers';
          if (s3) s3.className = 'on';
        } else {
          if (kicker) kicker.textContent = 'Transmission held';
          if (s4) s4.className = 'on';
        }
        if (p < 1) {
          out.textContent = scramble(target, Math.max(0, (p - 0.12) / 0.7));
          requestAnimationFrame(tick);
        } else if (!locked) {
          locked = true;
          finish();
        }
      } catch (e) {
        finish();
      }
    }

    setTimeout(finish, duration + 1500);
    tick();
  }

  function initAll() {
    var roots = document.querySelectorAll('.hw-tease');
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
